/* @flow */
// Top of the middle panel: what is playing right now, like a music app's header.
// The song gets the space (title, then artist); the station sits underneath as a
// line with its genres under it. While nothing plays yet, the station takes the lead.
import React from 'react'
import './StationHero.css'

export type Props = {
  name: string,
  image: string,
  genres: string[],
  title?: string,
  artist?: string,
  isAdvert?: boolean,
  playing?: boolean,
  reported?: boolean,
  onReportExplicit?: () => void
}

export default ({ name = '', image = '', genres = [], title = '', artist = '', isAdvert = false, playing = false, reported = false, onReportExplicit }: Props) => {
  if (!title) {
    return (
      <header className="station-hero station-hero--idle">
        { image && <img className="station-hero__art" src={ image } alt="" /> }
        <div className="station-hero__text">
          <span className="station-hero__kicker">Station</span>
          <h1 className="station-hero__name">{ name }</h1>
          { genres && genres.length > 0 && <p className="station-hero__genres">{ genres.join(' · ') }</p> }
        </div>
      </header>
    )
  }
  return (
    <header className={ `station-hero ${isAdvert ? 'station-hero--advert' : ''}` }>
      { image && <img className="station-hero__art" src={ image } alt="" /> }
      <div className="station-hero__text">
        <h1 className="station-hero__title" title={ title }>{ title }</h1>
        { artist && <p className="station-hero__artist">{ artist }</p> }
      </div>
      {/* Laptop: under the song. Phones and tablets: a row of its own under the artwork,
          so the song has the full width beside the artwork */}
      <div className="station-hero__meta">
        <p className="station-hero__station">
          { isAdvert && <span className="station-hero__label">Ad break</span> }
          <span className="station-hero__station-name">{ name }</span>
        </p>
        { genres && genres.length > 0 && <p className="station-hero__station-genres">{ genres.join(' · ') }</p> }
        {
          !isAdvert && onReportExplicit && (
            <button
              type="button"
              className="station-hero__report"
              onClick={ onReportExplicit }
              disabled={ reported }
              title="Report this song as explicit"
            >
              <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true" focusable="false">
                <path fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" d="M5 21V4h13l-3 4.5L18 13H5" />
              </svg>
              { reported ? 'Reported' : 'Report explicit' }
            </button>
          )
        }
      </div>
    </header>
  )
}
